<template>

  <section class="EmailDeliverySettings0005">
    <el-row :gutter="0" class="EmailDeliverySettingsHead">
         <router-link to="/sp/0002" class="Router__To__Destination"><i class="el-icon-close"></i></router-link>
      <el-col :span="6">
        <span class="EmailDeliverySettingsSpan">メール配信設定</span>
      </el-col>
      <el-col :span="12">
        <img src="../../assets/image/logo-new.png" alt="logo" class="ElnetLogo" />
      </el-col>
      <el-col :span="6"></el-col>
    </el-row>
    <el-row class="EmailDeliverySettingsBody">
      <el-form ref="form" :model="getform0005" :rules="getRules" label-position="top">
        <el-form-item label="設定対象テーマ">
          <span>{{GetthemeMaildialog}}</span>
        </el-form-item>
        <el-form-item label="媒体" prop="type" class="Delivery__email__media">
          <el-checkbox-group v-model="getform0005.type" v-if="elnet_user==0" >
            <el-checkbox label="1" name="type" v-if="news_article_flag && user_group_news_article_flag" :disabled="getNewsDisabledFlag">新聞</el-checkbox>
            <el-checkbox label="5" name="type" v-if="getMagazine_Article_Flag && getUserGroup_Magazine_Article_Flag" :disabled="getMagazineDisabledFlag">雑誌/WEB</el-checkbox>
            <el-checkbox label="3" name="type" v-if="web_news_article_flag && user_group_web_news_article_flag" :disabled="getWebDisabledFlag">WEB</el-checkbox>
          </el-checkbox-group>
          <el-checkbox-group v-model="getform0005.type" v-else>
            <el-checkbox label="1" name="type" :disabled="getNewsDisabledFlag">新聞</el-checkbox>
            <el-checkbox label="5" name="type" :disabled="getMagazineDisabledFlag">雑誌/WEB</el-checkbox>
            <el-checkbox label="3" name="type" :disabled="getWebDisabledFlag">WEB</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="配信先メールアドレス" prop="name1" class="Delivery__email__address">
          <el-input v-model="getform0005.name1" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="配信先メールアドレス(確認用)" prop="name2" class="Delivery__email__address__confirmation">
          <el-input v-model="getform0005.name2" placeholder=""></el-input>
        </el-form-item>
        <span class="unSubscribe__message">メール配信停止をご希望の方は、本サービスの管理者に連絡してください。</span>
        <el-form-item class="EmailSettingBtn__group">
          <!-- 2021/08/02  #11641  START -->
          <el-button type="primary" plain @click="open('form')" :disabled="Buttonpressed == 1">登録</el-button>
          <!-- 2021/08/02  #11641  END -->
          <el-button type="info" plain @click="gototop('form')">戻る</el-button>
        </el-form-item>
        <!-- <span class="Email__address__registered" v-if="AlertVisible">メールアドレスが登録されました。</span> -->
      </el-form>
    </el-row>
  </section>

</template>

<script>
//import Vue from "vue";
import router from "../../router";
import json from "../../components/config.json";
import { mapGetters } from "vuex";
//import Common from '../../common/CommonFunc.js'
  export default  {
    name: 'EmailDeliverySettings0005',
    props: [],
    mounted () {
    this.GetthemeMaildialog=this.getthemevalue0005;
    this.getform0005.name1='';
    this.getform0005.name2='';
    //get the news_article_flag from the session
    this.news_article_flag = this.getNews_Article_Flag
    //get the web_news_article_flag from the session
    this.web_news_article_flag = this.getWeb_News_Article_Flag
    this.elnet_user =  this.getElnetUser
    this.user_group_news_article_flag = this.getUserGroup_News_Article_Flag
    this.user_group_web_news_article_flag = this.getUserGroup_Web_News_Article_Flag

    /*commit done for loading top page when clicking close icon*/
    this.$store.commit("sp_Situation0001/setSelectedTheme", this.getSelectedTheme);
    this.$store.commit('sp_Situation0001/setSearchConditionKey', this.getSearchConditionKey);
    this.$store.commit("sp_Situation0001/setThemeNewsCount", 0);
    this.$store.commit('sp_Situation0001/setThemeWebCount', 0);
    this.$store.commit('sp_Situation0001/setThemeLoadCheck', 1);
    this.$store.commit('sp_Situation0001/setTodayArticleFlag', false);
    this.$store.commit('sp_Situation0001/setArticleSortCount', this.getArticleSortCount);
    this.$store.commit('sp_Situation0001/setIsDefaultDateLoading', 0);
    this.$store.commit('sp_Situation0001/setSelectedLabel', this.getSelectedLabel)
    /*commit done for loading top page when clicking close icon*/
    },
    data () {
      return {
        // 2021/08/02  #11641  START
        Buttonpressed: 0,
        // 2021/08/02  #11641  END
        GetthemeMaildialog:'',
        news_article_flag: false,
        web_news_article_flag: false,
        user_group_news_article_flag: false,
        elnet_user:'0',
        user_group_web_news_article_flag: false,
        // AlertVisible: false,
        form: {
          name1: '',
          name2: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: '',
          
        }
      }
    },
    methods: {
      gototop(formName) {
        this.$LogButtonEvent("0005","Return");
        this.$LogMethodIN("0005","gototop");
        this.$refs[formName].resetFields();
        this.getform0005.type=[];
        console.log(this.getSearchConditionKey)
        this.$store.commit("sp_Situation0001/setSelectedTheme", this.getSelectedTheme);
        this.$store.commit('sp_Situation0001/setSearchConditionKey', this.getSearchConditionKey);
        this.$store.commit("sp_Situation0001/setThemeNewsCount", 0);
        this.$store.commit('sp_Situation0001/setThemeWebCount', 0);
        this.$store.commit('sp_Situation0001/setThemeMagazineCount', 0);
        this.$store.commit('sp_Situation0001/setThemeLoadCheck', 1);
        this.$store.commit('sp_Situation0001/setTodayArticleFlag', false);
        this.$store.commit('sp_Situation0001/setArticleSortCount', this.getArticleSortCount);
        this.$store.commit('sp_Situation0001/setIsDefaultDateLoading', 0);
        this.$store.commit('sp_Situation0001/setSelectedLabel', this.getSelectedLabel)
        router.push({ name: "sp_0001" });
        this.$LogMethodOut("0005","gototop");
    },
    //Email Address validation
      open(formName) {
        this.$LogButtonEvent("0005","Registration");
        this.$LogMethodIN("0005","open");
        this.$refs[formName].validate(valid => {
        if (valid) {
          // 2021/08/02  #11641  START
          this.Buttonpressed= 1;
          // 2021/08/02  #11641  END 
          var checkWebNews=[]
          if(this.getform0005.type.length > 0)
          {
            //Check News is selected
            if(this.getform0005.type.indexOf("1") > -1)
            {
              checkWebNews.push(101)
            }
            //Check web News is selected
            if(this.getform0005.type.indexOf("3") > -1)
            {
              checkWebNews.push(3)
            }
            if(this.getform0005.type.indexOf("5") > -1)
            {
              checkWebNews.push(5)
            }
          }
          
          console.log(checkWebNews)
          
          var credentials = {
            theme_id:(this.getthemeid0005).toString(),
            data_kbn:parseInt(this.getdata_kbn),
            data_section:checkWebNews,
            mail_address:this.getform0005.name1
          };
          console.log(credentials);
          this.$store.dispatch('sp_Communication0005/MailDelivery',credentials).then(() => {
             
            var status = this.getStatus;
           // var errMsg = this.getMessageCode;

              if(status == 0){
                this.$alert(this.getErrorMessage, json["0003_send_success_title"], {
                  confirmButtonText: 'OK',
                }).then(() => {
                  this.$refs[formName].resetFields();
                  this.getform0005.type=[];
                  console.log(this.getSearchConditionKey)
                  this.$store.commit("sp_Situation0001/setSelectedTheme", this.getSelectedTheme);
                  this.$store.commit('sp_Situation0001/setSearchConditionKey', this.getSearchConditionKey);
                  this.$store.commit("sp_Situation0001/setThemeNewsCount", this.getThemeNewsCount);
                  this.$store.commit('sp_Situation0001/setThemeWebCount', this.getThemeWebCount);
                  this.$store.commit('sp_Situation0001/setThemeMagazineCount', this.getThemeMagazineCount);
                  this.$store.commit('sp_Situation0001/setThemeLoadCheck', this.getThemeLoadCheck);
                  this.$store.commit('sp_Situation0001/setArticleSortCount', this.getArticleSortCount);
                  this.$store.commit('sp_Situation0001/setIsDefaultDateLoading', 0);
                  this.$store.commit('sp_Situation0001/setSelectedLabel', this.getSelectedLabel)
                  router.push({name:"sp_0001"});
                })
              }
              else{
                this.$alert(this.getErrorMessage, json["0003_send_failure_title"], {
                  confirmButtonText: 'OK',
                });
              }
              // 2021/08/02  #11641  START
              this.Buttonpressed= 0;
              // 2021/08/02  #11641  END 
           })
            .catch((error) => {
                  console.log(error);
                  this.$alert(this.getErrorMessage, json["0003_send_failure_title"], {
                confirmButtonText: 'OK'
                      });
              // 2021/08/02  #11641  START
              this.Buttonpressed= 0;
              // 2021/08/02  #11641  END 
              });
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
			
         
        this.$LogMethodOut("0005","AlertVisible");    
      },
 
    },
    computed: {...mapGetters("sp_Situation0005", [
      "getform0005",
      "getthemevalue0005",
      "getthemeid0005",
      "getdata_kbn",
      "getStatus",
      "getErrorMessage",
      "getMessageCode",
      "getNewsDisabledFlag",
      "getWebDisabledFlag",
      "getMagazineDisabledFlag"]),
      ...mapGetters("sp_Situation0001", ["getSearchConditionKey",
                                        "getSelectedTheme",
                                        "getThemeNewsCount",
                                        "getThemeWebCount",
                                        "getThemeMagazineCount",
                                        "getThemeLoadCheck",
                                        "getArticleSortCount",
                                        "getSelectedLabel"]), 
      ...mapGetters("sp_ValidationHandler", [
        "getRules",
      ]),
     ...mapGetters("situation0001", [
        "getNews_Article_Flag",
        "getDefault_Font_Size",
        "getWeb_News_Article_Flag",
        "getUserGroup_News_Article_Flag",
        "getUserGroup_Web_News_Article_Flag" ,
        "getMagazine_Article_Flag",
        "getUserGroup_Magazine_Article_Flag" ,
        "getElnetUser"

    ])
    },
    beforeCreate(){
      //Common.Session.SP_CheckSessionExists_IfExpired_GoToLogout();
    }
}


</script>

<style scoped>
@import "0005.css";
@import "../../assets/css/customStyle.css";
</style>
